import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {NewSearchWidgetEntitiesItem} from "./new-search-widget.entities.item";
import {ScrollerWrapper} from "../../../../core/components/scroll-wrapper/scroll-wrapper";

export const NewSearchWidgetEntitiesList = observer(({
                                                       controller,
                                                       listModel,
                                                       isRecentSearchesList,
                                                       highlightedItemIndex,
                                                       shouldRenderListEmptyState,
                                                       onMouseEnter
                                                     }) => {
  const {state, device} = controller;
  const {isSmallView} = device;
  const {isListSingleView, isRecentSearchedActiveNavigation, isPopularAndResultsActiveNavigation} = state;
  const entities = isListSingleView ? listModel?.entities : listModel?.entitiesForDisplay;

  const scrollerProps = {
    className: classNames(styles.entities_list),
    wheelPropagation: true
  }

  const itemProps = {
    controller,
    isRecentSearchesList,
    listModel
  }

  return shouldRenderListEmptyState ? <div className={classNames(styles.entities_list_empty_state)}>{listModel?.emptyStateText}</div> :
    <ScrollerWrapper {...scrollerProps}>
      {
        entities?.map((entity, index) => {
          let isHighlighted = false;

          if (isRecentSearchedActiveNavigation) {
            isHighlighted = isRecentSearchesList && highlightedItemIndex === index
          } else if (isPopularAndResultsActiveNavigation) {
            isHighlighted = !isRecentSearchesList && highlightedItemIndex === index
          }

          return <NewSearchWidgetEntitiesItem
            entity={entity}
            isHighlighted={!isSmallView && isHighlighted}
            key={entity.id}
            index={index}
            onMouseEnter={onMouseEnter}
            {...itemProps}
          />
        })
      }
    </ScrollerWrapper>
});
